import { render, staticRenderFns } from "./GoodsEditor.vue?vue&type=template&id=061135ce&scoped=true&"
import script from "./GoodsEditor.vue?vue&type=script&lang=js&"
export * from "./GoodsEditor.vue?vue&type=script&lang=js&"
import style0 from "./GoodsEditor.vue?vue&type=style&index=0&id=061135ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061135ce",
  null
  
)

export default component.exports